import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { initMetaPixel } from './utils/metaPixel';
import { UrgencyTimer } from './components/UrgencyTimer';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { BonusBundle } from './components/BonusBundle';
import { MidCTA } from './components/MidCTA';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { PricingFAQ } from './components/PricingFAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-black text-white" data-id="element-0">
      <UrgencyTimer data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainSection data-id="element-4" />
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1.2
      }} className="relative w-full bg-black" data-id="element-5">
          <img src="https://cdn.magicpatterns.com/uploads/vM45sXWDCZKXcvi1FqfzoT/private_openrouter-generated-image-1775522680748.png" alt="" className="w-full h-auto object-cover max-h-[500px] pt-[20px] pb-[20px]" data-id="element-6" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/60 pointer-events-none" data-id="element-7" />
        </motion.div>
        <SolutionSection data-id="element-8" />
        <BonusBundle data-id="element-9" />
        <MidCTA data-id="element-10" />
        <Testimonials data-id="element-11" />
        <Guarantee data-id="element-12" />
        <PricingFAQ data-id="element-13" />
        <FinalCTA data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
      <StickyCTA data-id="element-16" />
    </div>;
}